module.exports = __webpack_public_path__ + "img/tools3.f0572fb8.svg";